import { MoleculeEntry } from '../types'
import { approvedContent, unreviewed } from './shared'

interface MoleculeSeed {
  slug: string
  moleculeName: string
  mechanism?: string
}

/**
 * Adding a molecule = adding one seed. No structural change needed (PRD §9).
 *
 * REQUIRES MEDICAL REVIEW — `mechanism` sentences are copied verbatim from PRD §18.
 * Class, approved uses, side effects and contraindications are intentionally undefined.
 */
const MOLECULE_SEEDS: MoleculeSeed[] = [
  {
    slug: 'semaglutida',
    moleculeName: 'Semaglutida',
    mechanism: 'A semaglutida atua como agonista do receptor de GLP-1.'
  },
  {
    slug: 'tirzepatida',
    moleculeName: 'Tirzepatida',
    mechanism: 'A tirzepatida atua sobre os receptores de GIP e GLP-1.'
  }
]

export const MOLECULES: MoleculeEntry[] = MOLECULE_SEEDS.map(({ slug, moleculeName, mechanism }) => ({
  kind: 'molecule' as const,
  slug,
  path: `/${slug}`,
  name: moleculeName,
  moleculeName,
  mechanism,
  published: false,
  requiresReview: true,
  review: unreviewed()
})).map(approvedContent)
